import { render, staticRenderFns } from "./ModalKasKecilRiwayat.vue?vue&type=template&id=5b0c72b3&scoped=true&"
import script from "./ModalKasKecilRiwayat.vue?vue&type=script&lang=js&"
export * from "./ModalKasKecilRiwayat.vue?vue&type=script&lang=js&"
import style0 from "./ModalKasKecilRiwayat.vue?vue&type=style&index=0&id=5b0c72b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0c72b3",
  null
  
)

export default component.exports